import type { ReactNode } from 'react';

export const symbol_nest_hello_doorbell: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M338.5-138.5Q280-197 280-280v-400q0-83 58.5-141.5T480-880q83 0 141.5 58.5T680-680v400q0 83-58.5 141.5T480-80q-83 0-141.5-58.5ZM579-180.83q41-40.84 41-99.17v-400q0-58.33-40.76-99.17-40.77-40.83-99-40.83Q422-820 381-779.17q-41 40.84-41 99.17v400q0 58.33 40.76 99.17 40.77 40.83 99 40.83Q538-140 579-180.83ZM536.5-583.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-480Zm56.5 216.5Q560-287 560-320t-23.5-56.5Q513-400 480-400t-56.5 23.5Q400-353 400-320t23.5 56.5Q447-240 480-240t56.5-23.5ZM448-287.91q-13-12.91-13-32T447.91-352q12.91-13 32-13T512-352.09q13 12.91 13 32T512.09-288q-12.91 13-32 13T448-287.91Z"
		/>
	</svg>
);
